import styled from 'styled-components';
import Gallery from 'components/ui/Gallery';
import withLabel from 'components/core/withLabel';

const AdminGallery = styled(Gallery).attrs({
  admin: true,
})``;

export default withLabel(AdminGallery);
